export default "__VITE_ASSET___u9rhMlY__"